import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import * as moment from 'moment';

interface MonthOption {
  label: string;
  date: Date;
  value: string;
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeComponent implements OnInit {

  months: MonthOption[] = [];
  selectedMonth: MonthOption;

  ngOnInit() {
    const currentMoment = moment();
    const currentYear = currentMoment.year();

    for (let yearOffset = -1; yearOffset <= 1; yearOffset++) {
      for (let month = 0; month < 12; month++) {
        const date = moment()
          .year(currentYear + yearOffset)
          .month(month)
          .startOf('month');

        this.months.push({
          label: date.format('MM/YYYY'),
          date: date.toDate(),
          value: date.format('YYYY-MM')
        });
      }
    }

    this.months.sort((a, b) => moment(a.value).diff(moment(b.value)));

    const currentMonthValue = currentMoment.format('YYYY-MM');
    const currentMonthObj = this.months.find(month => month.value === currentMonthValue);

    this.selectedMonth = currentMonthObj || this.months[0];
  }

  onMonthChange(event: any): void {
    this.selectedMonth = event.value;
  }

  changeMonth(direction: number) {
    const currentIndex = this.months.findIndex(month =>
      month.value === this.selectedMonth?.value
    );

    if (currentIndex === -1) return;

    let newIndex = currentIndex + direction;

    if (newIndex < 0) {
      newIndex = 0;
    } else if (newIndex >= this.months.length) {
      newIndex = this.months.length - 1;
    }

    this.selectedMonth = this.months[newIndex];

  }
}
